import {putQuoteShippingV2} from 'api/magento/cart/cart';
import {ENDPOINTS} from 'constants/endpoints';
import {OrderReviewTotalsType} from 'desktop/types/orderReviewTotalsType';
import {apiConfig} from 'libs/api/api';

/**
 * Calls api/rest/optimaxcheckout/v2/cart/totals endpoint which used in several places to avoid duplication
 */
// TODO: use Orval - GUSA-40457
export const getOrderReviewTotalsApi = ({
    collectTax,
    withTaxErrors,
}: {
    collectTax: boolean;
    withTaxErrors: boolean;
}) =>
    apiConfig.instanceGusaBackend<OrderReviewTotalsType>({
        method: 'get',
        params: {collectTax: collectTax ? 1 : 0, withTaxErrors: withTaxErrors ? 1 : 0},
        url: `${ENDPOINTS.CHECKOUT_GET_TOTALS_V2}`,
    });

/**
 * Calls api/rest/optimaxcheckout/v2/regular/cart/shipping which used in several places to avoid duplication
 */
export const saveShippingMethodApi = (code: string) =>
    putQuoteShippingV2('regular', {shipping_method: code});
